<template>
  <span
    class="MapControlTooltip"
    @mouseenter="isVisible = true"
    @mouseleave="isVisible = false"
    @click="isVisible = false"
  >
    <slot />
    <Transition name="MapControlTooltip__fade">
      <span v-if="isVisible" class="MapControlTooltip__bubble" role="tooltip">{{ text }}</span>
    </Transition>
  </span>
</template>

<script setup lang="ts">
import { ref } from 'vue'

defineProps<{ text: string }>()

const isVisible = ref(false)
</script>

<style lang="scss" scoped>
.MapControlTooltip {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.MapControlTooltip__bubble {
  position: absolute;
  right: calc(100% + 0.625rem);
  top: 50%;
  z-index: 1000;
  transform: translateY(-50%);
  min-width: max-content;
  max-width: 14rem;
  padding: 0.375rem 0.625rem;
  font-size: 0.75rem;
  font-weight: 500;
  line-height: 1.3;
  text-align: center;
  color: #fff;
  background-color: rgb(17 24 39);
  border-radius: 0.375rem;
  box-shadow:
    0 4px 6px -1px rgb(0 0 0 / 0.12),
    0 2px 4px -2px rgb(0 0 0 / 0.08);
  white-space: nowrap;
  pointer-events: none;
}

.MapControlTooltip__fade-enter-active,
.MapControlTooltip__fade-leave-active {
  transition:
    opacity 0.12s ease,
    visibility 0.12s ease;
}

.MapControlTooltip__fade-enter-from,
.MapControlTooltip__fade-leave-to {
  opacity: 0;
}
</style>
